import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./navBar.module.scss";
import logo from "../../asserts/images/napid.png";
import homeIcon from "../../asserts/images/home.png";
import adminIcon from "../../asserts/images/admin1.png";
import subscriptionIcon from "../../asserts/images/subscription.jpg";
import applicationsIcon from "../../asserts/images/applications.png";
import sleepIcon from "../../asserts/images/sleeptime.png";
import apkIcon from "../../asserts/images/appapk.png";
import jsIcon from "../../asserts/images/js.png";
import jsIcons from "../../asserts/images/icons8-plugin-64.png";
import intIcon from "../../asserts/images/icons8-document-128.png";
import ReportIcon from "../../asserts/images/icons8-pie-chart-report-50.png";
import { useSelector } from "react-redux";
import idIcon from "../../asserts/images/idlevelReport.png";
import applicationIcon from "../../asserts/images/applicationlevel.png";
import mobileIcon from "../../asserts/images/mobilelevel.png";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import ScienceIcon from '@mui/icons-material/Science';
import ScreenLockPortraitIcon from '@mui/icons-material/ScreenLockPortrait';


const NavBar = ({ role, onNavClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = useSelector((state) => state.auth.userRole);
  const [isReportsMenuOpen, setReportsMenuOpen] = useState(false); // State for submenu visibility
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isSubMenuOpen2, setIsSubMenuOpen2] = useState(false);
  const [isSubMenuOpenReport, setIsSubMenuOpenReport] = useState(false);
  const [isSubMenuOpen3, setIsSubMenuOpen3] = useState(false);
  const [isSubMenuOpenReport1, setIsSubMenuOpenReport1] = useState(false);
  const [isReportsOpen, setIsReportsOpen] = useState(false);


  const subMenuRef = useRef(null);
  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };
  const toggleSubMenuReport = () => {
    setIsSubMenuOpenReport(!isSubMenuOpenReport);
  };
  const toggleSubMenu2 = () => {
    setIsSubMenuOpen2(!isSubMenuOpen2);
  };
  const toggleSubMenu3 = () => {
    setIsSubMenuOpen3(!isSubMenuOpen3);
  };
  useEffect(() => {
    if (["/report4", "/report5", "/report6"].includes(location.pathname)) {
      setIsSubMenuOpenReport(true);
      setIsSubMenuOpen(true);
    }
  }, [location.pathname]);
  useEffect(() => {
    if (location.pathname === "/reports" || location.pathname === "/report3") {
      setIsReportsOpen(true);
    }
  }, [location.pathname]);
  useEffect(() => {
    if (["/report7", "/report8", "/report9"].includes(location.pathname)) {
      setIsSubMenuOpenReport(true);
      setIsSubMenuOpen2(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      [
        "/monthlyBillingReport",
        "/renewalBillingReport",
        "/mobileNumberupdationList",
      ].includes(location.pathname)
    ) {
      setIsSubMenuOpenReport1(true);
      setIsSubMenuOpen3(true);
    }
  }, [location.pathname]);
  useEffect(() => {
    const savedScroll = sessionStorage.getItem("submenuScroll");
    if (savedScroll && subMenuRef.current) {
      subMenuRef.current.scrollTop = parseInt(savedScroll, 10);
    }
  }, []);
  const handleNavClick = (navItem) => {
    onNavClick(navItem);
    //navigate(path); // Navigate without affecting submenu state
    const scrollPosition = subMenuRef.current?.scrollTop || 0;
    sessionStorage.setItem("submenuScroll", scrollPosition);

    const state = { role };
    switch (navItem) {
      case "home":
        navigate("/dashboard", { state });
        break;
      case "admin":
        navigate("/admin", { state });
        break;
      case "jstext":
        navigate("/jstext", { state });
        break;
      case "jsplugin":
        navigate("/jsplugin", { state });
        break;
      case "integrationsteps":
        navigate("/integrationsteps", { state });
        break;
      case "superadmin":
        navigate("/superadmin", { state });
        break;
      case "applications":
        navigate("/applications", { state });
        break;
      case "subscription":
        navigate("/subscription", { state });
        break;
      case "create-subscription":
        navigate("/create-subscription", { state });
        break;
      case "sleep":
        navigate("/sleeptime", { state });
        break;
      case "app-apk":
        navigate("/appapk", { state });
        break;
      case "js-logo":
        navigate("/jslogo", { state });
        break;
      case "applicationslist":
        navigate("/applicationslist", { state });
        break;

      case "configuration":
        navigate("/configuration", { state });
        break;
      case "maintenacePage":
        navigate("/maintenancePage", { state });
        break;
      case "id":
        navigate("/reports", { state });
        break;
      case "application":
        navigate("/report2", { state });
        break;
      case "mobile":
        navigate("/report3", { state });
        break;
      case "adminReport":
        navigate("/report4", { state });
        break;
      case "adminReport2":
        navigate("/report5", { state });
        break;
      case "adminReport3":
        navigate("/report6", { state });
        break;
      case "superAdminReport":
        navigate("/report7", { state });
        break;
      case "superAdminReport2":
        navigate("/report8", { state });
        break;
      case "superAdminReport3":
        navigate("/report9", { state });
        break;
      case "securedID":
        navigate("/securedID", { state });
        break;
      case "monthlyBillingReport":
        navigate("/monthlyBillingReport", { state });
        break;
      case "renewalBillingReport":
        navigate("/renewalBillingReport", { state });
        break;
      case "mobileNumberUpdationReport":
        navigate("/mobileNumberupdationList", { state });
        break;
      case "2fa-report":
        navigate('/2fa-report', { state });
        break;
      case "forensic-report":
        navigate('/forensic-report', { state });
        break;
      case "2fa-pages-config":
        navigate('/2fa-pages-config', { state });
        break;
      case "issuer-key-management":
        navigate('/issuer-key-management', { state });
        break;
      default:
        break;
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <aside className={styles.sideNav}>
      <img src={logo} alt="NapID Logo" className={styles.logo} />
      <div className={styles.separator}></div>
      {/* Conditionally render Home for roles other than REPORT_ADMIN */}
      {userRole !== "REPORT_ADMIN" && (
        <div
          className={`${styles.navItem} ${isActive("/dashboard") ? styles.active : ""
            }`}
          onClick={() => handleNavClick("home")}>
          <img src={homeIcon} alt="Home" className={styles.navIcon} />
          <span className={styles.navText}>Home</span>
        </div>
      )}
      {/* NAPID_ADMIN role navigation */}
      {userRole === "NAPID_ADMIN" && (
        <>
          <div
            className={`${styles.navItem} ${isActive("/subscription") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("subscription")}>
            <img
              src={subscriptionIcon}
              alt="Subscription Details"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Subscription</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/superadmin") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("superadmin")}>
            <img src={adminIcon} alt="Super Admin" className={styles.navIcon} />
            <span className={styles.navText}>Admin</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/appapk") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("app-apk")}>
            <img src={apkIcon} alt="App APK" className={styles.navIcon} />
            <span className={styles.navText}>Mobile App</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/jslogo") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("js-logo")}>
            <img src={jsIcon} alt="JS Logo" className={styles.navIcon} />
            <span className={styles.navText}>JS Logo</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/2fa-pages-config") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("2fa-pages-config")}>
            <ScreenLockPortraitIcon className={styles.subMenuIcon} color="error" />
            <span className={styles.navText}>2FA Pages Config</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/applicationslist") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("applicationslist")}>
            <img
              src={applicationsIcon}
              alt="Applications List"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Applications List</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/configuration") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("configuration")}>
            <img
              src={applicationsIcon}
              alt="Configuration"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Configuration</span>
          </div>
          {/* Main "Report" Menu */}
          <div
            className={`${styles.navItem} ${["/report", "/report4", "/report6", "/report7", "/report9"].some(isActive) ? styles.active : ""
              ? styles.active : ""
              }`}
            onClick={toggleSubMenuReport}>
            <img src={ReportIcon} alt="Reports" className={styles.navIcon} />
            <span className={styles.navText}>Report</span>
            <span className={styles.dropdownIcon}>
              {isSubMenuOpenReport ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </span>
          </div>

          {/* First-Level Submenu: Napid Admin & All Admin */}
          {isSubMenuOpenReport && (
            <div className={styles.subMenu}>
              <ul className={styles.subMenuList}>
                {/* Napid Admin Report */}
                <li
                  className={`${styles.navItem} ${["/report", "/report4", "/report6"].some(isActive) ? styles.active : ""
                    ? styles.active : ""
                    }`} style={{ width: '118%' }}
                  onClick={toggleSubMenu}>
                  <img
                    src={ReportIcon}
                    alt="Napid Admin Report"
                    className={styles.subMenuIcon}
                  />
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                      gap: "4px", // spacing between text and icon
                    }}>
                    Napid Admin Report
                    <span className={styles.dropdownIcon}>
                      {isSubMenuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </span>
                  </span>
                </li>

                {/* Napid Admin Report Sub-items */}
                {isSubMenuOpen && (
                  <ul className={styles.subSubMenuList}>
                    <li
                      className={`${styles.subMenuItem} ${isActive("/report4") ? styles.active : ""
                        }`}
                      onClick={() => handleNavClick("adminReport")}>
                      <img
                        src={idIcon}
                        alt="ID Level Report"
                        className={styles.subMenuIcon}
                      />
                      ID Level
                    </li>
                    <li
                      className={`${styles.subMenuItem} ${isActive("/report6") ? styles.active : ""
                        }`}
                      onClick={() => handleNavClick("adminReport3")}>
                      <img
                        src={applicationIcon}
                        alt="Mobile User Level"
                        className={styles.subMenuIcon}
                      />
                      Mobile User Level
                    </li>
                  </ul>
                )}

                {/* All Admin Report */}
                <li
                  className={`${styles.subMenuItem} ${["/report", "/report7", "/report9"].some(isActive) ? styles.active : ""
                    }`}
                  onClick={toggleSubMenu2}>
                  <img
                    src={ReportIcon}
                    alt="All Admin Report"
                    className={styles.subMenuIcon}
                  />
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                      gap: "4px", // spacing between text and icon
                    }}>
                    All Admin Report
                    <span className={styles.dropdownIcon}>
                      {isSubMenuOpen2 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </span>
                  </span>
                </li>

                {/* All Admin Report Sub-items */}
                {isSubMenuOpen2 && (
                  <ul className={styles.subSubMenuList}>
                    <li
                      className={`${styles.subMenuItem} ${isActive("/report7") ? styles.active : ""
                        }`}
                      onClick={() => handleNavClick("superAdminReport")}>
                      <img
                        src={idIcon}
                        alt="ID Level Report"
                        className={styles.subMenuIcon}
                      />
                      ID Level
                    </li>
                    <li
                      className={`${styles.subMenuItem} ${isActive("/report9") ? styles.active : ""
                        }`}
                      onClick={() => handleNavClick("superAdminReport3")}>
                      <img
                        src={applicationIcon}
                        alt="Mobile User Level"
                        className={styles.subMenuIcon}
                      />
                      Mobile User Level
                    </li>
                  </ul>
                )}
              </ul>
            </div>
          )}

          <div
            className={`${styles.navItem} ${isActive("/securedID") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("securedID")}>
            <img
              src={applicationsIcon}
              alt="securedID"
              className={styles.navIcon}
            />
            <span className={styles.navText}>secured ID</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/issuer-key-management") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("issuer-key-management")}>
            <img src={ReportIcon} alt="Issuer key management" className={styles.navIcon} />
            <span className={styles.navText}>Issuer Management</span>
          </div>

          <div
            className={`${styles.navItem} ${["/mobileNumberupdationList", "/monthlyBillingReport", "/renewalBillingReport"].some(isActive) ? styles.active : ""
              }`}
            onClick={toggleSubMenu3} // Toggle submenu on click
          >
            <img
              src={ReportIcon}
              alt="Billing Report"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Billing Report</span>
            <span className={styles.dropdownIcon}>
              {isSubMenuOpen3 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </span>
          </div>

          {isSubMenuOpen3 && (
            <div>
              {/* Monthly Billing Report */}
              <div style={{ marginLeft: '10px' }}
                className={`${styles.navItem} ${isActive("/monthlyBillingReport") ? styles.active : ""
                  }`}
                onClick={() => handleNavClick("monthlyBillingReport")}>
                <img
                  src={idIcon}
                  alt="Monthly Billing Report"
                  className={styles.navIcon}
                />
                <span className={styles.navText}>Monthly Billing Report</span>
              </div>

              {/* Renewal Billing Report */}
              <div style={{ marginLeft: '10px' }}
                className={`${styles.navItem} ${isActive("/renewalBillingReport") ? styles.active : ""
                  }`}
                onClick={() => handleNavClick("renewalBillingReport")}>
                <img
                  src={applicationIcon}
                  alt="Renewal History Report"
                  className={styles.navIcon}
                />
                <span className={styles.navText}>Renewal History Report</span>
              </div>
              <div style={{ marginLeft: '10px' }}
                className={`${styles.navItem} ${isActive("/mobileNumberupdationList") ? styles.active : ""
                  }`}
                onClick={() => handleNavClick("mobileNumberUpdationReport")}>
                <img
                  src={applicationIcon}
                  alt="Renewal History Report"
                  className={styles.navIcon}
                />
                <span className={styles.navText}>Mobile number updation Report</span>
              </div>
            </div>
          )}

        </>
      )}

      {/* SUPER_ADMIN role navigation */}
      {userRole === "SUPER_ADMIN" && (
        <>
          <div
            className={`${styles.navItem} ${isActive("/admin") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("admin")}>
            <img src={adminIcon} alt="Super Admin" className={styles.navIcon} />
            <span className={styles.navText}>Admin</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/applications") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("applications")}>
            <img
              src={applicationsIcon}
              alt="Applications"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Applications</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/jstext") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("jstext")}>
            <img src={jsIcon} alt="JS Text" className={styles.navIcon} />
            <span className={styles.navText}>JS Text</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/2fa-pages-config") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("2fa-pages-config")}>
            <ScreenLockPortraitIcon className={styles.subMenuIcon} color="error" />
            <span className={styles.navText}>2FA Pages Config</span>
          </div>
          {/* <div
            className={`${styles.navItem} ${
              isActive("/jsplugin") ? styles.active : ""
            }`}
            onClick={() => handleNavClick("jsplugin")}>
            <img src={jsIcons} alt="JS Plugin" className={styles.navIcon} />
            <span className={styles.navText}>JS Plugin</span>
          </div>
          <div
            className={`${styles.navItem} ${
              isActive("/integrationsteps") ? styles.active : ""
            }`}
            onClick={() => handleNavClick("integrationsteps")}>
            <img
              src={intIcon}
              alt="Integration Steps"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Integration Steps</span>
          </div> */}
          {/* <div className={styles.navItem}> */}
          <div
            className={`${styles.navItem} ${["/reports", "/report3"].some(isActive) ? styles.active : ""
              }`}
            onClick={() => setIsReportsOpen(!isReportsOpen)}>
            <img src={ReportIcon} alt="Reports" className={styles.navIcon} />
            <span className={styles.navText}>Reports</span>

            {/* Dropdown Arrow Icon */}
            <span className={styles.dropdownIcon}>
              {isReportsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </span>
          </div>

          {/* Submenu for Reports */}

          {isReportsOpen && (
            <div className={styles.subMenu}>
              <ul className={styles.subMenuList}>
                <li
                  className={`${styles.subMenuItem} ${isActive("/reports") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("id")}>
                  <img
                    src={idIcon}
                    alt="ID Level Report"
                    className={styles.subMenuIcon}
                  />
                  ID Level
                </li>

                <li
                  className={`${styles.subMenuItem} ${isActive("/report3") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("mobile")}>
                  <img
                    src={mobileIcon}
                    alt="Mobile User Report"
                    className={styles.subMenuIcon}
                  />
                  <span className={styles.subMenuText}>Mobile User Level</span>
                </li>
                <li
                  className={`${styles.subMenuItem} ${isActive("/2fa-report") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("2fa-report")}>
                  {/* <img
                    src={FingerprintIcon}
                    alt="2FA Report"
                    className={styles.subMenuIcon}
                  /> */}
                  <FingerprintIcon className={styles.subMenuIcon} color="error" />
                  <span className={styles.subMenuText}>2FA Report</span>
                </li>
              </ul>
            </div>
          )}

          <div
            className={`${styles.navItem} ${["/report", "/report7", "/report9"].some(isActive) ? styles.active : ""
              }`}
            onClick={toggleSubMenu2}>
            <img src={ReportIcon} alt="Reports" className={styles.navIcon} />
            <span className={styles.navText}>All Admin Report</span>

            {/* Dropdown icon */}
            <span className={styles.dropdownIcon}>
              {isSubMenuOpen2 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </span>
          </div>

          {isSubMenuOpen2 && (
            <div className={styles.subMenu}>
              <ul className={styles.subMenuList}>
                <li
                  className={`${styles.subMenuItem} ${isActive("/report7") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("superAdminReport")} // Use handleNavClick for ID Level
                >
                  <img
                    src={idIcon}
                    alt="ID Level Report"
                    className={styles.subMenuIcon}
                  />
                  ID Level
                </li>
                {/* <li
                className={`${styles.subMenuItem} ${
                  isActive("/report8") ? styles.active : ""
                }`}
                onClick={() => handleNavClick("superAdminReport2")} // Use handleNavClick for Application Level
              >
                 <img src={applicationIcon} alt="ID Level Report" className={styles.subMenuIcon} />
                Application Level
              </li> */}
                <li
                  className={`${styles.subMenuItem} ${isActive("/report9") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("superAdminReport3")} // Use handleNavClick for Application Level
                >
                  <img
                    src={applicationIcon}
                    alt="ID Level Report"
                    className={styles.subMenuIcon}
                  />
                  Mobile User Level
                </li>
              </ul>
            </div>
          )}
        </>
      )}
      {/* ADMIN role navigation */}
      {userRole === "ADMIN" && (
        <>
          <div
            className={`${styles.navItem} ${isActive("/applications") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("applications")}>
            <img
              src={applicationsIcon}
              alt="Applications"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Applications</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/jstext") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("jstext")}>
            <img src={jsIcon} alt="JS Text" className={styles.navIcon} />
            <span className={styles.navText}>JS Text</span>
          </div>
          <div
            className={`${styles.navItem} ${isActive("/2fa-pages-config") ? styles.active : ""
              }`}
            onClick={() => handleNavClick("2fa-pages-config")}>
            <ScreenLockPortraitIcon className={styles.subMenuIcon} color="error" />
            <span className={styles.navText}>2FA Pages Config</span>
          </div>
          {/* <div
            className={`${styles.navItem} ${
              isActive("/jsplugin") ? styles.active : ""
            }`}
            onClick={() => handleNavClick("jsplugin")}>
            <img src={jsIcons} alt="JS Plugin" className={styles.navIcon} />
            <span className={styles.navText}>JS Plugin</span>
          </div>
          <div
            className={`${styles.navItem} ${
              isActive("/integrationsteps") ? styles.active : ""
            }`}
            onClick={() => handleNavClick("integrationsteps")}>
            <img
              src={intIcon}
              alt="Integration Steps"
              className={styles.navIcon}
            />
            <span className={styles.navText}>Integration Steps</span>
          </div> */}
          <div
            className={`${styles.navItem} ${["/reports", "/report3"].some(isActive) ? styles.active : ""
              }`}
            onClick={() => setIsReportsOpen(!isReportsOpen)}>
            <img src={ReportIcon} alt="Reports" className={styles.navIcon} />
            <span className={styles.navText}>Reports</span>

            {/* Dropdown Arrow Icon */}
            <span className={styles.dropdownIcon}>
              {isReportsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </span>
          </div>

          {/* Submenu for Reports */}

          {isReportsOpen && (
            <div className={styles.subMenu}>
              <ul className={styles.subMenuList}>
                <li
                  className={`${styles.subMenuItem} ${isActive("/reports") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("id")}>
                  <img
                    src={idIcon}
                    alt="ID Level Report"
                    className={styles.subMenuIcon}
                  />
                  ID Level
                </li>

                <li
                  className={`${styles.subMenuItem} ${isActive("/report3") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("mobile")}>
                  <img
                    src={mobileIcon}
                    alt="Mobile User Report"
                    className={styles.subMenuIcon}
                  />
                  <span className={styles.subMenuText}>Mobile User Level</span>
                </li>
              </ul>
            </div>
          )}
        </>
      )}
      {/* REPORT_ADMIN role navigation */}
      {userRole === "REPORT_ADMIN" && (
        <>
          <div
            className={`${styles.navItem} ${["/reports", "/report3"].some(isActive) ? styles.active : ""
              }`}
            onClick={() => setIsReportsOpen(!isReportsOpen)}>
            <img src={ReportIcon} alt="Reports" className={styles.navIcon} />
            <span className={styles.navText}>Reports</span>

            {/* Dropdown Arrow Icon */}
            <span className={styles.dropdownIcon}>
              {isReportsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </span>
          </div>

          {/* Submenu for Reports */}

          {isReportsOpen && (
            <div className={styles.subMenu}>
              <ul className={styles.subMenuList}>
                <li
                  className={`${styles.subMenuItem} ${isActive("/reports") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("id")}>
                  <img
                    src={idIcon}
                    alt="ID Level Report"
                    className={styles.subMenuIcon}
                  />
                  ID Level
                </li>

                <li
                  className={`${styles.subMenuItem} ${isActive("/report3") ? styles.active : ""
                    }`}
                  onClick={() => handleNavClick("mobile")}>
                  <img
                    src={mobileIcon}
                    alt="Mobile User Report"
                    className={styles.subMenuIcon}
                  />
                  <span className={styles.subMenuText}>Mobile User Level</span>
                </li>
              </ul>
            </div>
          )}
        </>
      )}
      {
        <div
          className={`${styles.navItem} ${isActive("/forensic-report") ? styles.active : ""
            }`}
          onClick={() => handleNavClick("forensic-report")}>
          <ScienceIcon className={styles.subMenuIcon} color="error" />
          <span className={styles.navText}>Forensic Report</span>
        </div>
      }
    </aside>
  );
};

export default NavBar;
